export const getToken = () => sessionStorage.getItem("access_token");

export const getTokenExpiry = () => {
    const expiresAt = sessionStorage.getItem("expires_at");
    return expiresAt ? Number(expiresAt) : null;
};

export const isTokenExpired = () => {
    const expiry = getTokenExpiry();
    return expiry !== null && Date.now() > expiry;
};

export const setToken = (token: string, expiresIn: number) => {
    sessionStorage.setItem("access_token", token);
    sessionStorage.setItem("expires_at", (Date.now() + expiresIn * 1000).toString());
};

export const clearToken = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("expires_at");
};
